import {
  LISTA_AREAS_CONHECIMENTO,
  LISTA_AREAS_CONHECIMENTO_SUCESSO,
  GET_DISCIPLINAS_POR_AREA,
  GET_DISCIPLINAS_POR_AREA_SUCCESS
} from 'constants/ActionTypes';

export const listaAreasConhecimento = () => ({
  type: LISTA_AREAS_CONHECIMENTO
});

export const listaAreasConhecimentoSucesso = (payload) => ({
  type: LISTA_AREAS_CONHECIMENTO_SUCESSO,
  payload
});

export const getDisciplinasPorArea = (areaId) => ({
  type: GET_DISCIPLINAS_POR_AREA,
  payload: areaId
});

export const getDisciplinasPorAreaSuccess = (areaId, disciplinas) => ({
  type: GET_DISCIPLINAS_POR_AREA_SUCCESS,
  payload: { areaId, disciplinas }
});
